<template>
  <div>
    <form>
      <div
        v-for="(field, index) in fields"
        :key="index"
        class="row field"
      >
        <div class="col-9">
          <input
            v-model="fields[index].name"
            type="text"
            class="form-control"
            @keyup="updated"
            @blur="updated"
          >
        </div>
        <div class="col-2">
          <select
            v-model="fields[index].type"
            class="form-control"
            @change="updated"
          >
            <option
              v-for="(type, typeKey) in types"
              :key="typeKey"
              :value="typeKey"
            >
              {{ type }}
            </option>
          </select>
        </div>
        <div class="col-1">
          <button
            class="btn btn-danger btn-block"
            @click.prevent="remove(index)"
          >
            <i class="fa fa-trash" />
          </button>
        </div>
      </div>
      <ui-quote>
        <a
          href="#"
          @click.prevent="add"
        >
          {{ $t('Create a new one') }}
        </a>
      </ui-quote>
    </form>
  </div>
</template>

<script>
export default {
  name: 'AppCredentialsFields',
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      fields: [],
    };
  },
  computed: {
    types() {
      return { text: this.$t('Text'), number: this.$t('Number') };
    },
  },
  watch: {
    value(v) {
      this.fields = Object.keys(v).map(i => ({ name: i, type: v[i] }));
    },
  },
  methods: {
    updated() {
      const obj = {};
      this.fields.forEach(e => {
        if (e.name.length > 0) {
          obj[e.name] = e.type;
        }
      });
      this.$emit('input', obj);
    },
    remove(index) {
      // eslint-disable-next-line no-alert
      if (window.confirm(this.$t('Are you sure?'))) {
        this.fields.splice(index, 1);
      }
      this.updated();
    },
    add() {
      this.fields.push({
        name: `New${this.fields.length}`,
        type: 'text',
      });
      this.updated();
    },
  },
};
</script>

<style lang="scss" scoped>
  .field:not(:last-child) {
    margin-bottom: 10px;
  }
</style>
